import styled from 'styled-components';

export default styled.div`
    .facebook-login-button {
        background-color: ${({ theme }) => theme.colors.facebook};
        width: 100%;
        color: #fff;
    }
`;
